import type { Fp } from "@workspace/core";
import { either } from "fp-ts";

import type { MethodKeys } from "./utility-types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Fn<Args extends any[] = any[], Ret = any> = Fp.Fn<Args, Ret>;
type UnknownFn = Fp.UnknownFn;

function throwify<E extends Error, A>(value: either.Either<E, A>) {
  if (either.isLeft(value)) throw value.left;

  return value.right;
}

function combine<Args extends unknown[], T extends Fn<Args, unknown> | undefined>(fns: T[]) {
  return (...args: Args) => fns.map((fn) => fn?.(...args));
}

function bounded<T extends object, U extends MethodKeys<T>>(object: T | undefined, methodName: U) {
  const method = object?.[methodName];
  if (typeof method !== "function") return undefined;

  return method.bind(object) as T[U];
}

export { bounded, combine, throwify };
export type { Fn, UnknownFn };
